<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14LNDOC/tc-custom/9781471170447.jpg?1718183001496" alt="This image is the cover for the book Mystery at Stormy Point, Seaview Stables Adventures"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mystery at Stormy Point, Seaview Stables Adventures
      </h1>
      <p class="bookDescription body article font2">
        <b>Join Bryony and Red on another adventure in the “enchanting” Seaview Stables series from the bestselling author of <i>The Pony with No Name</i> (<i>World Book Day</i>).</b><br/><br/>Bryony has settled into life at Brook Dale, especially now she’s the owner of her dream pony Red! And with the whole town gearing up for the Three Coves Gymkhana, there’s plenty to keep her and her new friends busy. Bryony can’t wait to show everyone just how brilliant Red is, especially her former enemy Georgina Brook. Then, one day, while practising for the gymkhana, she notices a strange light coming from the disused lighthouse at Stormy Point. The lighthouse has been empty for years and Bryony is determined to find out just who—or what—is living there . . . <br/><br/>Will Bryony get to the bottom of the mystery? And just how far will Georgina go to destroy Bryony’s gymkhana dreams . . . <br/><br/><b>Praise for <i>The Pony with No Name</i></b><br/><br/>“Will delight both animal and adventure lovers!” —<i>Lancashire Post</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tracey Corderoy
      </h2>
      
      <p class="authorDescription body article">Tracey Corderoy lives near Gloucester in the Cotswolds with her family and a host of lively, lovely pets. Once a trained primary school teacher, Tracey is now an award-winning children&rsquo;s writer and has published over 45 books since 2010, including the <I>Shifty McGifty</I> and <I>Hubble Bubble</I> series (Nosy Crow). She loves visiting schools, libraries and bookshops, bringing her stories to life with bright, engaging events, and inspiring children to want to be writers too! Visit her website at&#160;http://www.traceycorderoy.com/.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Simon & Schuster
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?47c7c922